import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppUtils } from 'src/app/helpers/app.utils';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { PagedPendingGroupedModel } from '../../../models/paged.pending.grouped.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RawImageAssignUpsertComponent } from '../assign-upsert/raw.image.assign.upsert.component';
import { RawImageService } from 'src/app/chief-editor/services/raw.image.service';
import { RemoveAssigneeModel } from 'src/app/chief-editor/models/remove.assignee.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-raw-image-pending-grouped',
    templateUrl: './raw.image.pending.grouped.component.html',
    styleUrls: ['./raw.image.pending.grouped.component.scss']
})
export class RawImagePendingGroupedComponent implements OnInit {
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    pagedPendingGroupedDetails = new PagedPendingGroupedModel();
    totalRecords = 0;
    isModelLoaded = false;

    get urls() {
        return PageUrls;
    }

    constructor(private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private rawImageService: RawImageService,
        private modalService: NgbModal,
        private router: Router) {
    }

    ngOnInit() {
        this.tableModel = new TableModel();
        this.totalRecords = 0;
        this.subscriptions = [];

        this.initSubscribers();
        this.getImages();

    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getImages());
        this.subscriptions.push(subscription);
    }

    getImages = () => {
        setTimeout(() => {
            this.ngxSpinnerService.show();
        });
        this.rawImageService.pendingGroupedList(this.tableModel)
            .subscribe(data => {
                this.pagedPendingGroupedDetails = data;
                this.totalRecords = data.totalCount;
                this.ngxSpinnerService.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openAssignUpsert(unixTimeStamp: number, contributorId: string): void {
        const modal = this.modalService.open(RawImageAssignUpsertComponent);
        modal.componentInstance.unixTimeStamp = unixTimeStamp;
        modal.componentInstance.contributorId = contributorId;
        modal.result.then(() => {
            this.getImages();
        });
    }

    removeAssignee(unixTimeStamp: number, editorId: string): void {
        const model = new RemoveAssigneeModel();
        model.editorId = editorId;
        model.unixTimeStamp = unixTimeStamp;
        this.ngxSpinnerService.show();
        this.rawImageService.removeAssignee(model).subscribe(() => {
            this.ngxSpinnerService.hide();
            this.getImages();
            this.toastr.success('Removed successfully.');
        }, error => {
            this.ngxSpinnerService.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }

    sendForApproval(unixTimeStamp: number): void {
        if (!confirm('Are you sure you want to send these images for approval?')) {
            return;
        }
        this.ngxSpinnerService.show();
        this.rawImageService.sendForApproval(unixTimeStamp).subscribe(() => {
            this.ngxSpinnerService.hide();
            this.getImages();
            this.toastr.success('Images have been successfully sent for approval.');
        }, error => {
            this.ngxSpinnerService.hide();
            AppUtils.processErrorResponse(this.toastr, error);
        });
    }

    openImageCount(unixTimeStamp: number, contributorId: string) {
        setTimeout(() => {
            this.router.navigateByUrl(
                `${PageUrls.ChiefEditor.RawImageManage}?unixTimeStamp=${unixTimeStamp}&contributerId=${contributorId}`);
        });
    }

}
